import {
  CheckBadgeIcon,
  JobPositionStatistics,
  Loading,
  Typography,
  UserInfoIcon,
  UsersIcon,
  WaitingIcon,
} from "@cpj-ai/panel-npm-package";
import {
  AuthAccountJobPositionAssignmentStatusChoices,
  useGetJobPositionsQuery,
  useGetJobSuggestionsQuery,
} from "@graphql/generated";
import { Divider } from "@heroui/react";
import { addIsConfirmedToJobSuggestionResult } from "@modules/JobPosition/utils";
import { useParams } from "react-router-dom";
import StatusCard from "./components/StatusCard";

const StatisticsTabContent = () => {
  const { id } = useParams();

  const { data, loading } = useGetJobPositionsQuery({
    variables: {
      id: id || "",
    },
    skip: !id,
  });

  const { data: jobSuggestions } = useGetJobSuggestionsQuery({
    variables: {
      jobPositionId: id || "",
    },
    skip: !id,
  });

  const suggestions = addIsConfirmedToJobSuggestionResult(
    jobSuggestions?.admin?.jobSuggestionResult?.edges[0]?.node?.items?.edges ?? [],
  );

  const jobSeekersAwaiting = suggestions?.filter((item) => item?.node?.isConfirmed)?.length;

  const remainingJobSeekers = suggestions?.filter((item) => !item?.node?.isConfirmed)?.length;

  const report = data?.admin?.jobPositions?.edges[0]?.node?.report;

  return (
    <div className="flex flex-col gap-8 p-6">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="flex gap-4 justify-between ">
            <StatusCard
              status="People in the pool:"
              value={remainingJobSeekers || 0}
              icon={<UsersIcon className="w-9 h-9  fill-blue-500" />}
            />
            <StatusCard
              status="Job Suggested:"
              value={jobSeekersAwaiting || 0}
              icon={<UserInfoIcon className="w-9 h-9  stroke-blue-500" />}
            />
            <StatusCard
              status="Waiting for approval:"
              value={
                report?.assignmentStatusCounts?.find(
                  (item) => item?.status === AuthAccountJobPositionAssignmentStatusChoices.AWAITING_JOBSEEKER_APPROVAL,
                )?.count || 0
              }
              icon={<WaitingIcon className="w-7 h-9  fill-blue-500 stroke-white" />}
            />
            <StatusCard
              status="Final approval:"
              value={
                report?.assignmentStatusCounts?.reduce((acc, item) => {
                  if (
                    item?.status !== AuthAccountJobPositionAssignmentStatusChoices.REJECTED_BY_JOBSEEKER &&
                    item?.status !== AuthAccountJobPositionAssignmentStatusChoices.AWAITING_JOBSEEKER_APPROVAL
                  ) {
                    return acc + (item?.count || 0);
                  }
                  return acc;
                }, 0) || 0
              }
              icon={<CheckBadgeIcon className="w-9 h-9  stroke-blue-500" />}
            />
          </div>
          <Divider />
          <Typography className="text-xl">Company operations report :</Typography>
          <JobPositionStatistics report={report} />
        </>
      )}
    </div>
  );
};

export default StatisticsTabContent;
